/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from '../actor/defs.defs.js'
import * as LabelDefs from '../../../com/atproto/label/defs.defs.js'

const $nsid = 'app.bsky.notification.listNotifications'

export { $nsid }

/** Enumerate notifications for the requesting account. Requires auth. */
const main = l.query(
  $nsid,
  l.params({
    reasons: l.optional(l.array(l.string())),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
    priority: l.optional(l.boolean()),
    cursor: l.optional(l.string()),
    seenAt: l.optional(l.string({ format: 'datetime' })),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    notifications: l.array(l.ref<Notification>((() => notification) as any)),
    priority: l.optional(l.boolean()),
    seenAt: l.optional(l.string({ format: 'datetime' })),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output

type Notification = {
  $type?: 'app.bsky.notification.listNotifications#notification'
  uri: l.AtUriString
  cid: l.CidString
  author: ActorDefs.ProfileView

  /**
   * The reason why this notification was delivered - e.g. your post was liked, or you received a new follower.
   */
  reason:
    | 'like'
    | 'repost'
    | 'follow'
    | 'mention'
    | 'reply'
    | 'quote'
    | 'starterpack-joined'
    | 'verified'
    | 'unverified'
    | 'like-via-repost'
    | 'repost-via-repost'
    | 'subscribed-post'
    | 'contact-match'
    | l.UnknownString
  reasonSubject?: l.AtUriString
  record: l.LexMap
  isRead: boolean
  indexedAt: l.DatetimeString
  labels?: LabelDefs.Label[]
}

export type { Notification }

const notification = l.typedObject<Notification>(
  $nsid,
  'notification',
  l.object({
    uri: l.string({ format: 'at-uri' }),
    cid: l.string({ format: 'cid' }),
    author: l.ref<ActorDefs.ProfileView>((() => ActorDefs.profileView) as any),
    reason: l.string<{
      knownValues: [
        'like',
        'repost',
        'follow',
        'mention',
        'reply',
        'quote',
        'starterpack-joined',
        'verified',
        'unverified',
        'like-via-repost',
        'repost-via-repost',
        'subscribed-post',
        'contact-match',
      ]
    }>(),
    reasonSubject: l.optional(l.string({ format: 'at-uri' })),
    record: l.lexMap(),
    isRead: l.boolean(),
    indexedAt: l.string({ format: 'datetime' }),
    labels: l.optional(
      l.array(l.ref<LabelDefs.Label>((() => LabelDefs.label) as any)),
    ),
  }),
)

export { notification }
